import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

import { Link } from 'react-router-dom';

import SvgIcon from "@mui/material/SvgIcon";
import IconLogo from "../IconLogo";

import '../App.css'; 
import { Tooltip } from '@mui/material';
import { title } from '@uiw/react-md-editor/commands';

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const links = [
    { id: "L0", path: "/video", title: "Video" },
    { id: "L1", path: "/podcasts", title: "Podcast"},
    { id: "L2", path: "/contact",  title: "Contact" },
    { id: "L3", path: "/terms", title: "Terms & Conditions" },
  ];

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  
  const logo_style = { alignSelf: 'center', width: '60px', height: 'auto', marginLeft: '10px', marginBottom:"-20px"} 
  return (
    <AppBar position="static" sx={{ height: 60 }}>

        <Toolbar disableGutters>
          <SvgIcon 
            style={logo_style}
            sx={{ display: { xs: 'none', md: 'flex' }}}>
            <IconLogo />
          </SvgIcon>
          <Link
            to="/video"
            style={{
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <Typography variant="h6"  sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.2rem',
              color: 'inherit',
              textDecoration: 'none',
              //marginLeft: "-10px",
            }}>
            ClipThoughts
            </Typography>
          </Link>
          
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {
                links.map((el) => (
                  <MenuItem
                    key={el.id} 
                    component={Link} 
                    to={el.path} 
                    onClick={handleCloseNavMenu} 
                    icon={el.icon} 
                    style={{textTransform: "capitalize"}}
                    className="menuItem"
                    >
                    <Typography textAlign="center">{el.title.toLowerCase()}</Typography>
                  </MenuItem>
              ))
              }
            </Menu>
          </Box>
          
            <SvgIcon
              style={logo_style}
              sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconLogo />
            </SvgIcon>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="/video"
              sx={{
                ml: 1, // Add left margin
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              ClipThoughts
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {links.map((el) => (
              <>
                <Tooltip title={el.title} size="md" arrow>
                  <Button
                    key={el.id}
                    component={Link}
                    to={el.path}
                    onClick={handleCloseNavMenu}
                    sx={{ marginTop: 1, color: 'white', display: 'block'}}
                    size='large'
                    style={{textTransform: "capitalize"}}
                    className="menuItem"
                  >
                  {el.title}
                  </Button>
                </Tooltip>
              </>
            ))}
          </Box>
        </Toolbar>
    </AppBar>
  );
}
export default ResponsiveAppBar;